export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11777.62fc26fd.jpg";